import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Payments.module.css';
import { CheckSmall } from '../../icons';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const Header = () => (
  <header className={styles.hero}>
    <div className={`${styles.container} ${styles.heroGrid}`}>
      <div>
        <div className={`${styles.breadcrumb} ${styles.reveal} ${styles.d1}`}>
          <Link to="/">Fyntiq Business</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <Link to="/#features">Features</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCur}>Payments</span>
        </div>
        <h1 className={`${styles.reveal} ${styles.d2}`}>
          One checkout.<br /><span className={styles.hl}>Every way to pay.</span>
        </h1>
        <p className={`${styles.heroSub} ${styles.reveal} ${styles.d3}`}>
          Accept Fyntiq Wallet, cards, Apple Pay, Google Pay, Cash App Pay, bank transfer, and financing — through invoices, payment links, or your existing checkout.
        </p>
        <div className={`${styles.heroCta} ${styles.reveal} ${styles.d4}`}>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Get started free</Link>
          <a href="#how" className={styles.btnOutlineHero}>See how it works</a>
        </div>
        <div className={`${styles.heroNote} ${styles.reveal} ${styles.d5}`}>
          <span><CheckSmall />PCI-compliant</span>
          <span><CheckSmall />Free to start</span>
          <span><CheckSmall />No code</span>
        </div>
      </div>

      <div className={`${styles.heroVisual} ${styles.reveal} ${styles.d3}`}>
        <div className={`${styles.floatChip} ${styles.fcCash}`}>
          <div className={`${styles.fcIc} ${styles.fcIcY}`}><CheckSmall /></div>
          <div><div className={styles.fcLab}>Payment</div><div className={styles.fcVal}>Approved</div></div>
        </div>
        <div className={`${styles.floatChip} ${styles.fcPayout}`}>
          <div className={`${styles.fcIc} ${styles.fcIcG}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#2EB66E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 3v13m0 0l-4-4m4 4l4-4M5 21h14" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Deposited</div><div className={styles.fcVal}>$1,240.00</div></div>
        </div>

        <div className={styles.payCard}>
          <div className={styles.pcTop}>
            <div className={styles.pcMerchant}>
              <div className={styles.pcLogo}>N</div>
              <div><div className={styles.pcMname}>Northbeam Studio</div><div className={styles.pcMsub}>Secure checkout</div></div>
            </div>
            <span className={styles.pcPaid}>● Secure</span>
          </div>
          <div className={styles.pcAmtLab}>Amount due</div>
          <div className={styles.pcAmt}>$1,240.00</div>
          <div className={styles.pcMethods}>
            <div className={`${styles.pcM} ${styles.pcMSel}`}>
              <span className={styles.ic}>
                <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="7" width="18" height="12" rx="2" /><path d="M3 11h18" /></svg>
              </span>
              Wallet
            </div>
            <div className={styles.pcM}>
              <span className={styles.ic}>
                <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18" /></svg>
              </span>
              Card
            </div>
            <div className={styles.pcM}>
              <span className={styles.ic}>
                <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 21h18M5 21V10M19 21V10M3 10l9-6 9 6" /></svg>
              </span>
              Bank
            </div>
            <div className={styles.pcM}>
              <span className={styles.ic}>
                <svg viewBox="0 0 24 24" width="18" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
              </span>
              Finance
            </div>
          </div>
          <button type="button" className={styles.pcPay}>Pay $1,240.00 →</button>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
